export const legalFaqData = {
  header: {
    badge: {
      text: "Legal Queries",
      icon: "HelpOutlineIcon"
    },
    title: "Property Legal Services - Frequently Asked Questions",
    description: "Find answers to common questions about our legal verification and property documentation services. Get clarity on your property investment journey."
  },
  faqs: [
    { 
      question: 'What is Property Legal Verification?', 
      answer: 'Property legal verification is a comprehensive process where our legal experts thoroughly examine all property documents, title deeds, approvals, and compliance certificates to ensure your property investment is secure, legally sound, and free from any disputes or liabilities.',
      category: 'General'
    },
    { 
      question: 'Why is legal verification necessary before purchasing property?', 
      answer: 'Legal verification is crucial to protect your investment from future disputes, title issues, financial liabilities, and regulatory non-compliance. It ensures the property has clear ownership, all approvals are valid, and there are no hidden legal encumbrances that could affect your investment.',
      category: 'Importance'
    },
    { 
      question: 'Which documents are verified in property legal verification?', 
      answer: 'We verify all critical documents including Encumbrance Certificate, Sale Deed, Land Purchase Deed, Building Approvals, Development Agreement, Commencement Certificate, Possession Letter, Completion Certificate, Fire NOC, Aviation NOC, Environmental Clearance, and 18+ essential property documents to ensure complete legal compliance.',
      category: 'Documents'
    },
    { 
      question: 'How long does the legal verification process take?', 
      answer: 'Typically, our comprehensive legal verification process takes 5-7 business days. This includes document collection, thorough verification, title search, and preparing a detailed legal verification report with expert recommendations and risk assessment.',
      category: 'Timeline'
    },
    { 
      question: 'What are the benefits of using your legal verification services?', 
      answer: 'Our legal verification service offers complete protection from legal disputes, saves thousands by avoiding future legal battles, provides fast processing with expert support, ensures full transparency with detailed reports, and gives you peace of mind with professional expertise backed by years of experience.',
      category: 'Benefits'
    },
    { 
      question: 'What happens if legal issues are found in the property?', 
      answer: 'If we identify any legal issues, we provide a detailed report highlighting the concerns, risk assessment, and expert recommendations on how to address them. We guide you through the process of resolving issues with the developer or seller before finalizing your purchase.',
      category: 'Process'
    },
    { 
      question: 'How much does property legal verification cost?', 
      answer: 'Our legal verification services are designed to be cost-effective with transparent pricing. The cost varies based on the complexity and type of property, but it is a small investment compared to the potential losses from legal disputes. Contact us for a customized quote.',
      category: 'Pricing'
    },
    { 
      question: 'Do you handle property dispute resolution?', 
      answer: 'Yes, we provide expert legal assistance for resolving property disputes including mediation, contract negotiation, settlement agreements, and legal representation. Our team helps you resolve conflicts efficiently and negotiate favorable terms for all parties involved.',
      category: 'Services'
    },
    { 
      question: 'What is included in the legal verification report?', 
      answer: 'Our comprehensive report includes verification status of all documents, title search results, ownership chain analysis, risk assessment with severity levels, compliance status with regulations, expert recommendations, and next steps for a safe property investment.',
      category: 'Report'
    },
    { 
      question: 'Can I verify property documents myself?', 
      answer: 'While you can attempt to verify documents yourself, it is highly recommended to use professional legal experts. We have the knowledge, experience, and access to government records needed to conduct thorough verification and identify hidden risks that may not be apparent to non-professionals.',
      category: 'Professional'
    },
    { 
      question: 'What is the difference between Sale Deed and Agreement for Sale?', 
      answer: 'An Agreement for Sale is a preliminary contract that outlines the terms and conditions of the property transaction, while the Sale Deed is the final legal document that transfers ownership from seller to buyer. The Agreement for Sale comes before the Sale Deed execution.',
      category: 'Documents'
    },
    { 
      question: 'Why is RERA compliance important?', 
      answer: 'RERA compliance ensures that the developer has registered the project with the Real Estate Regulatory Authority, maintaining all transactions in an escrow account, and adhering to construction timelines. This protects buyers from project delays and provides legal recourse in case of disputes.',
      category: 'Compliance'
    },
    { 
      question: 'What is Encumbrance Certificate and why is it important?', 
      answer: 'An Encumbrance Certificate is a crucial document that certifies the property is free from any financial or legal liabilities such as mortgages, loans, or legal disputes. We verify encumbrances for the last 30 years to ensure complete title clarity and protect your investment.',
      category: 'Documents'
    },
    { 
      question: 'What happens if a property lacks Completion Certificate?', 
      answer: 'A Completion Certificate is mandatory for obtaining utilities like water, power, and drainage. Without it, you cannot legally occupy the property. If this is missing, we recommend not proceeding with the purchase until the developer obtains this certificate from the municipal authorities.',
      category: 'Compliance'
    },
    { 
      question: 'Do you verify commercial properties as well?', 
      answer: 'Yes, we provide legal verification services for all types of properties including residential apartments, independent houses, commercial properties, plots, and commercial spaces. Our comprehensive verification process applies to all property types.',
      category: 'Coverage'
    }
  ]
};



